import { IntegrationIconProps } from './types';

const Twitch = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 10H20V16H22V10Z" fill="#6445A2" />
    <path d="M15 10H17V16H15V10Z" fill="#6445A2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 8L6.56799 4H28V19L22 25H17L13.886 28H10V25H5V8ZM22 21L26 17V6H9V21H13V24L16 21H22Z"
      fill="#6445A2"
    />
  </svg>
);
export default Twitch;
